module.exports = __webpack_public_path__ + "static/media/icons_Bilan MDT - Mckenzie num‚rique.dd8c4c84.svg";